import { DashboardApi } from "./api";
import { QueryKeyFactory } from "@shared/api/queries/queryKeyFactory";
import { useSmartQuery } from "@shared/api/queries/hooks";
import { useRemoteUtilityId } from "@shared/selectors/globalSelectors";

export const useDashboardData = () => {
  const utilityId = useRemoteUtilityId();

  // Step 1: Check if utilityId is available
  const enabled = !!utilityId;

  // Step 2: Update overview query with enabled check
  const overview = useSmartQuery(
    QueryKeyFactory.module.communication.overview(),
    () => {
      const data = DashboardApi.overview(utilityId);
      return data;
    },
    {
      enabled: enabled, // Changed from !shouldSkip to enabled
    }
  );

  // Step 3: Update listOverview query with enabled check
  const listOverview = useSmartQuery(
    QueryKeyFactory.module.communication.listsOverview(),
    async () => {
      return await DashboardApi.listOverview(utilityId);
    },
    {
      enabled: enabled, // Changed from !shouldSkip to enabled
    }
  );

  // Step 4: Update channelStats query with enabled check
  const channelStats = useSmartQuery(
    QueryKeyFactory.module.communication.channelStat(),
    async () => {
      return await DashboardApi.channelStats(utilityId);
    },
    {
      enabled: enabled, // Changed from !shouldSkip to enabled
    }
  );

  // Step 5: Update channelPerformance query with enabled check
  const channelPerformance = useSmartQuery(
    QueryKeyFactory.module.communication.channelPerformance(),
    async () => {
      return await DashboardApi.channelPerformance(utilityId);
    },
    {
      enabled: enabled, // Changed from !shouldSkip to enabled
    }
  );

  // Step 6: Update workflowPerformance query with enabled check
  const workflowPerformance = useSmartQuery(
    QueryKeyFactory.module.communication.workflowPerformance(),
    async () => {
      return await DashboardApi.workflowPerformance(utilityId);
    },
    {
      enabled: enabled, // Changed from !shouldSkip to enabled
    }
  );

  // Step 7: Update workflowStats query with enabled check
  const workflowStats = useSmartQuery(
    QueryKeyFactory.module.communication.workflowStats(),
    async () => {
      return await DashboardApi.workflowStats(utilityId);
    },
    {
      enabled: enabled, // Changed from !shouldSkip to enabled
    }
  );

  const queries = [
    overview,
    listOverview,
    channelStats,
    channelPerformance,
    workflowPerformance,
    workflowStats,
  ];

  return {
    overview,
    listOverview,
    channelStats,
    channelPerformance,
    workflowPerformance,
    workflowStats,
    isError: queries.some((q) => q.isError),
    errors: queries.filter((q) => q.isError).map((q) => q.error),
  };
};
